/* eslint-disable no-param-reassign */
import React from 'react';
import AbstractComponent from './AbstractComponent';
import ContextHelper from './ContextHelper';
import Editor from './Editor';

export default class Collection extends AbstractComponent {

    constructor(props, context = {}, ss = null) {

        super(props, context, ss);

        this.waitRef = new Promise((resolve) => {

            this.waitRefAction = resolve;
        });
    }

    /** @override */
    initEditor(props) {

        props['data-editable'] = 1;
        props['data-editable-type'] = 'flex';
        props['data-editable-placeholder'] = this.props.placeholder;
        props['data-editable-classname'] = this.getStorageClassName();
        props['data-editable-name'] = this.getRole();
        props['data-editable-id'] = this.getStorageId();
        props['data-editable-arrayable'] = '1';
        props['data-editable-data'] = this.getValue();

        // legacy version
        props['className'] += ' editable';
        props['data-name'] = this.getRole();
        props['data-type'] = 'flex';

        if (this.props.schema)
            props['data-editable-schema'] = `/custom/resource/admin/static/js/schema/${this.props.schema}.js`;

        props['ref'] = (el) => {

            if (el) {

                const
                    template = el.firstChild,
                    names = [];

                if (template) {

                    const prefix = Editor.getInstance().version == 'v1'
                        ? 'ui.'
                        : '';

                    template
                        .querySelectorAll('[data-name]')
                        .forEach((element) => {

                            // support legacy flex editable fields
                            element.innerText = `{{ ${prefix}${element.dataset.name} }}`;
                            names.push(
                                Editor.getInstance().version == 'v1'
                                    ? element.dataset.name
                                    : { name: element.dataset.name, type: 'text' },
                            );
                        });

                    el.dataset.editableTemplate = this.template = template.innerHTML;
                    el.dataset.editableAttributes = JSON.stringify(names);

                    template.remove();
                }

                if (Editor.isEditMode())

                    setInterval(() => {

                        if (el.innerText == '') {

                            el.classList.add('empty');
                            el.style.setProperty('--placeholder', `"${this.props.placeholder}"`);
                        }
                        else {

                            el.classList.remove('empty');
                        }
                    }, 1000);

                this.waitRefAction(el);
            }
        };
    }

    updateContent(value) {

        this.state.value = value;
        this
            .waitRef
            .then((el) => {

                if (Editor.isEditMode()) {

                    el.dataset.editableData = value;
                    el.dataset.editableValue = value; // v2
                }

                const prefix = Editor.getInstance().version == 'v1'
                    ? 'ui.'
                    : '';

                let
                    html = '',
                    items = null;

                try {

                    items = JSON.parse(value);
                }
                // eslint-disable-next-line no-empty
                catch (e) {
                }

                const makeTemplate = (item) => {

                        let { template } = this;
                        Object
                            .keys(item)
                            .forEach((name) => {

                                template = template.replaceAll(`{{ ${prefix}${name} }}`, item[name]);
                            });

                        html += template;
                    };

                if (Array.isArray(items))

                    Array
                        .from(items)
                        .forEach(makeTemplate);

                else

                if (items)
                    makeTemplate(items);


                el.classList.remove('empty');
                el.innerHTML = html;
            });
    }

    getRole() {

        const
            context = this.getContext(),
            prefix = context?.prefix ?? context?.role ?? null,
            { role } = this.props;

        return prefix
            ? `${prefix}${role[0].toUpperCase()}${role.substring(1)}`
            : role;
    }

    /** @override */
    getContext() {

        const context = super.createContext();

        // disable editable for inner blocks
        return ContextHelper.assign(Object.assign(
            context,
            { disabled: true },
        ));
    }

    /** @override */
    getContent() {

        // @todo: change to template tag

        // by render block template
        return <div style={{ display: 'none' }}>{ this.props.children }</div>;
    }

    getProps() {

        const props = {};
        if (!Editor.isEditMode())
            props['ref'] = this.createRefWithoutEditor.bind(this);

        return Object.assign(super.getProps(), props);
    }

    createRefWithoutEditor(el) {

        const
            template = el.firstChild,
            names = [];

        if (template) {

            const prefix = Editor.getInstance().version == 'v1'
                ? 'ui.'
                : '';

            template
                .querySelectorAll('[data-name]')
                .forEach((element) => {

                    // support legacy flex editable fields
                    element.innerText = `{{ ${prefix}${element.dataset.name} }}`;
                    names.push(
                        Editor.getInstance().version == 'v1'
                            ? element.dataset.name
                            : { name: element.dataset.name, type: 'text' },
                    );
                });

            this.template = template.innerHTML;
        }

        this.waitRefAction(el);
    }

}